<select-criteria [softDelete]="true" [selection]="false" [(modal)]="criteriaModal" [language]="language"
    [selectedEntity]="selectedEntity" [matrixList]="selectedEntity.metrics" [engagementMetrics]="selectedEntity.metrics"
    (modalChange)="criteriaModalChange.emit($event)" (updateEngagementMetrics)="onUpdateEngagementMetrics($event)">
    <ng-container head>
        <div class="flex flex-row items-center justify-between pb-8">
            <h5 [@first] class="text-zen font-medium text-3xl">
                {{ "txtExtraCriteria" | translate:language:ModuleNames.Common }}
            </h5>
            <a (click)="onOpenCriteriaModal()" class="btn exp uppercase leading-12 h-12 block rounded px-5">
                {{ "txt_new_criteria" | translate:language:ModuleNames.Shared }}
            </a>
        </div>
    </ng-container>
</select-criteria>